import {PropertyList, PropertyListItem, view, Link} from '@sail/ui';
import {useAnalytics} from '@stripe-internal/inline-data';
import {defineMessages, useIntl} from 'react-intl';
import {safeWindowOpen} from '@stripe-internal/safe-links';

const messages = defineMessages({
  platformLink: {
    id: 'mse_inline_data.contact_info_section.platform_link',
    description: 'Label for the platform link',
    defaultMessage: 'Website',
  },
  platformEmail: {
    id: 'mse_inline_data.contact_info_section.platform_email',
    description: 'Label for the platform email',
    defaultMessage: 'Email',
  },
  platformPhone: {
    id: 'mse_inline_data.contact_info_section.platform_phone',
    description: 'Label for the platform phone',
    defaultMessage: 'Phone number',
  },
});

export const ExpressDeleteContactListItem = ({
  label,
  testId,
  href,
  link,
}: {
  label: string;
  testId: string;
  href?: string;
  link?: string;
}) => {
  const analytics = useAnalytics();

  if (!href || !link) {
    return <></>;
  }

  return (
    <PropertyListItem
      label={
        <view.div css={{fontWeight: 'normal', font: 'label.small'}}>
          {label}
        </view.div>
      }
      data-testid={testId}
      value={
        <Link
          onPress={() => {
            safeWindowOpen(href);
            analytics.action(
              'uh_express_delete_account_platform_details_click',
              {link},
            );
          }}
        >
          <view.div
            css={{
              textOverflow: 'ellipsis',
              display: 'block',
              overflow: 'hidden',
              width: 'fill',
              whiteSpace: 'nowrap',
              font: 'label.small.emphasized',
            }}
          >
            {link}
          </view.div>
        </Link>
      }
    />
  );
};

export const ContactInfoSection = ({
  platformLink,
  platformEmail,
  platformPhone,
}: {
  platformLink?: string;
  platformEmail?: string;
  platformPhone?: string;
}) => {
  const intl = useIntl();

  return (
    <view.div>
      <PropertyList
        css={{
          stack: 'y',
          gap: 'small',
        }}
      >
        <ExpressDeleteContactListItem
          label={intl.formatMessage(messages.platformLink)}
          testId="express-delete-account-platform-link"
          href={platformLink}
          link={platformLink}
        />
        <ExpressDeleteContactListItem
          label={intl.formatMessage(messages.platformEmail)}
          testId="express-delete-account-platform-email"
          href={`mailto:${platformEmail}`}
          link={platformEmail}
        />
        <ExpressDeleteContactListItem
          label={intl.formatMessage(messages.platformPhone)}
          testId="express-delete-account-platform-phone"
          href={`tel:${platformPhone}`}
          link={platformPhone}
        />
      </PropertyList>
    </view.div>
  );
};
